import React, { FC, Suspense } from 'react';
import ErrorBoundary from 'ocfe/src/error/ErrorBoundary';

const withBlankSuspense = <T extends {}>(Comp: FC<T>) => {
  return (props: T) => {
    return (
      <ErrorBoundary>
        <Suspense fallback={<></>}>
          <Comp {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
};

const IconPicker = withBlankSuspense(React.lazy(() => import(/* webpackChunkName: "IconPicker"*/ './IconPicker')));
const IconPickerDropdown = withBlankSuspense(
  React.lazy(() => import(/* webpackChunkName: "IconPickerDropdown"*/ './IconPickerDropdown')),
);
const IconPickerIcon = withBlankSuspense(
  React.lazy(() => import(/* webpackChunkName: "IconPickerIcon"*/ './IconPickerIcon')),
);

export type { PickableIconPack, PickableIconLookup } from './types';
export { IconPicker, IconPickerDropdown, IconPickerIcon };
